import axios from 'axios';
import {bytesToSize} from '../helpers/FileHelper';

export default class SlackService {

    static send(message) {
        try {
            if (message) {
                let page = decodeURI(window.location.href.replace(/(^\w+:|^)\/\//, ''));
                let webhook = null;
                axios.get('/api/slack')
                    .then(function (response) {
                        webhook = response.data.webhook_url && response.data.webhook_url.length > 0 ? response.data.webhook_url : null;
                        if (webhook) {
                            axios.post(webhook, JSON.stringify({
                                'text': `${page}\n${message}`.replace(/[",]+/g, '')
                            }))
                        }
                    });
            }
        } catch (error) {
            SlackService.send(`>*Failed send*: ${error.message.toString()}`);
            return null;
        }
    }

    static getCallerPath() {
        try {
            const stack = new Error().stack;
            const lines = stack.split('\n');
            const callerLine = lines[3] || '';
            const match = callerLine.match(/\/Front\/(.+?)(?:\?|$)/);
            return match ? match[1] : callerLine.trim();
        } catch (e) {
            return 'unknown';
        }
    }

    static prepareData(error) {
        try {
            const path = this.getCallerPath();
            const status = error.response?.status || 'unknown';
            const detail = error.response?.data?.errors?.detail
                || error.response?.data?.message
                || error.message
                || 'Unknown error';
            const url = error.config?.url || '';

            return `>*Path:* ${path}\n>*Status:* ${status}\n>*Error:* ${detail}\n>*URL:* ${url}`;
        } catch (e) {
            return null;
        }
    }

    static prepareTranscriptionData(model) {
        for (const [key, value] of Object.entries(model)) {
            if (String(key).length > 0 &&
                String(key) !== 'null' &&
                String(key) !== 'undefined' &&
                (String(key) === 'size' || String(key) === 'extension') &&
                String(value) !== 'object' &&
                String(value) !== '' &&
                !String(value).includes('http') &&
                typeof value !== 'object'
            ) {
                if (String(key) === 'size') {
                    model[key] = `*${value} (${bytesToSize(value)})*`;
                } else {
                    model[key] = `*${value}*`;
                }
            } else if (typeof value == 'object' && String(value) !== 'null' && String(value) !== 'undefined') {
                this.prepareTranscriptionData(value);
            } else {
                delete model[key];
            }
        }
        return JSON.stringify(model, null, 2) || '';
    }

    static loop(model) {
        for (const [key, value] of Object.entries(model)) {
            if (String(key).length > 0 &&
                String(key) !== 'null' &&
                String(key) !== 'undefined' &&
                String(value) !== 'object' &&
                String(value) !== '' &&
                !String(value).includes('http') &&
                typeof value !== 'object'
            ) {
                model[key] = `*${value}*`;
            } else if (typeof value == 'object' && String(value) !== 'null' && String(value) !== 'undefined') {
                this.loop(value);
            } else if (String(key).length > 0 && String(value) === 'null' || String(value) === 'undefined') {
                model[key] = `*${value}*`;
            }
        }
        return model;
    }
}
